module.exports = __webpack_public_path__ + "static/media/interactionNew.c14238b5.svg";